import { motion } from "framer-motion";
import { ShieldCheck, FileCheck, Lock, Building2 } from "lucide-react";

const trustItems = [
  {
    icon: Building2,
    title: "UK Incorporated",
    description: "We're a registered UK company. Real people, real address, real accountability, not an anonymous platform.",
  },
  {
    icon: FileCheck,
    title: "KYC Verified",
    description: "Everyone on AdV3nture goes through identity verification via Stripe. No fake profiles, no time wasters.",
  },
  {
    icon: Lock,
    title: "End-to-End Encrypted",
    description: "Your conversations and documents stay private. We don't read your messages, and we never will.",
  },
  {
    icon: ShieldCheck,
    title: "Compliance First",
    description: "Regulatory considerations were built into the platform architecture from day one, not bolted on later.",
  },
];

const TrustSection = () => {
  return (
    <section className="py-10 md:py-14 section-teal" aria-label="Trust and compliance">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-xs font-medium text-primary/80 uppercase tracking-widest mb-3">Trust & Security</p>
          <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">
            Built to be <span className="text-gradient">trusted</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Security and compliance aren't features we added later. They're the foundation everything else sits on.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-5xl mx-auto">
          {trustItems.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="rounded-xl bg-card/70 backdrop-blur-xl p-6 text-center teal-ring-hover transition-all duration-300"
              style={{ border: "1px solid hsl(174 65% 45% / 0.15)" }}
            >
              <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-gradient-to-br from-primary/20 to-secondary/10 border border-primary/15 mb-4">
                <item.icon className="w-5 h-5 text-primary" />
              </div>
              <h3 className="font-display font-semibold mb-2 text-sm">{item.title}</h3>
              <p className="text-xs text-muted-foreground leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
